"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _this = this;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Animate_1 = require("../../Animate");

var context_1 = require("../context");

var asyncReducer_1 = require("../../utils/asyncReducer");

var EnterEmail_1 = __importDefault(require("../EnterEmail"));

var Loader_1 = __importDefault(require("../../Loader"));

var classnames_1 = __importDefault(require("classnames"));

exports.default = function (_a) {
  var onSuccess = _a.onSuccess,
      className = _a.className,
      inputClassName = _a.inputClassName,
      buttonClassName = _a.buttonClassName,
      loaderClassName = _a.loaderClassName;

  var _b = asyncReducer_1.useAsyncReducer(),
      _c = _b[0],
      loading = _c.loading,
      error = _c.error,
      data = _c.data,
      _d = _b[1],
      setLoading = _d.setLoading,
      setError = _d.setError,
      setData = _d.setData;

  var xya = context_1.useXyAccountContext();

  var _e = react_1.useState(''),
      email = _e[0],
      setEmail = _e[1];

  var onSubmit = function onSubmit(ev) {
    return __awaiter(_this, void 0, void 0, function () {
      var e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            ev.preventDefault();
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            setLoading();
            return [4
            /*yield*/
            , xya.sendPasswordResetEmail(email)];

          case 2:
            _a.sent();

            setData(true);
            onSuccess();
            return [3
            /*break*/
            , 4];

          case 3:
            e_1 = _a.sent();
            console.log(e_1);
            setError(e_1.message);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return react_1.default.createElement("form", {
    className: classnames_1.default('d-flex flex-column', className),
    onSubmit: onSubmit
  }, react_1.default.createElement(Animate_1.SlideInLeft, {
    id: 'email'
  }, react_1.default.createElement(EnterEmail_1.default, {
    label: 'Password Reset',
    hint: 'Enter your email and we will send instructions to reset your password',
    className: inputClassName,
    value: email,
    onChange: setEmail
  })), error ? react_1.default.createElement("p", {
    className: 'text-danger mb-2'
  }, error) : '', loading ? react_1.default.createElement("div", {
    className: classnames_1.default('text-center', loaderClassName)
  }, react_1.default.createElement(Loader_1.default, null)) : data ? '' : react_1.default.createElement(Animate_1.SlideInLeft, {
    id: 'continue'
  }, react_1.default.createElement("button", {
    type: 'submit',
    className: classnames_1.default('btn w-100', buttonClassName)
  }, "Continue")));
};